<template>
  <div v-if="assignment.updatedAt" class="assignment-last-update d-flex align-items-center">
    <mdicon name="History" />
    Last edited {{ toTimeFromNow(assignment.updatedAt) }}
  </div>
</template>

<script lang="ts">
import type { Assignment } from '@/types/Models/Assignment'
import { defineComponent, computed, type ComputedRef } from 'vue'
import { toTimeFromNow } from '@/services/Helpers'
import { useAssignmentSummaryStore } from '@/store/assignmentSummary'

export default defineComponent({
  name: 'LastEdited',
  setup() {
    const assignmentSummaryStore = useAssignmentSummaryStore()

    const assignment: ComputedRef<Assignment> = computed(() => assignmentSummaryStore.assignment as Assignment)

    return {
      assignment,
      toTimeFromNow,
    }
  },
})
</script>
